export default {"src":"/_next/static/media/step2.7e5c1443.svg","height":58,"width":58};